<template>
  <form-container :title="stageTitle">
      <p class="lead">If you have a question about making a claim you may find the answer within the <router-link to="/claimsguide">help</router-link> section.</p>      
      <h3 class="contact-section-header">Claims</h3>
      <p>To discuss an existing insurance claim:</p>
      <table v-if="window.width >= 768" class="table table-stacked">
        <thead>
          <tr>
            <th>Email</th>
            <th>Phone</th>
            <th>Information &amp; opening hours</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><a class="contact-section-link" href="mailto:gadget.claims@taurus.gi">gadget.claims@taurus.gi</a></td>
            <td><a class="contact-section-link" href="tel:0330 175 7850">0330 175 7850</a></td>
            <td>From 09:00am to 17:30pm (Mon-Fri)</td>
          </tr>
          <tr>
            <th colspan="3">Please include your claim reference number or policy number when contacting us.</th>
          </tr>
        </tbody>
      </table>
      <ul v-else>
        <li><a class="contact-section-link" href="mailto:gadget.claims@taurus.gi">gadget.claims@taurus.gi</a></li>
        <li><a class="contact-section-link" href="tel:0330 175 7850">0330 175 7850</a> From 09:00am to 17:30pm (Mon-Fri)</li>
        <li>Please include your claim reference number or policy number when contacting us.</li>
      </ul>
      <h3 class="contact-section-header">Complaints</h3>
      <p>We always aim to provide a great service, but if you have a complaint please write to us</p>
      <table v-if="window.width >= 768" class="table">
        <thead>
          <tr>
            <th>Email</th>
            <th>Address</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><a class="contact-section-link" href="mailto:claimscomplaints@taurus.gi">claimscomplaints@taurus.gi</a></td>
            <td>The Customer Relations Team, Virgin Money Gadget Insurance, Suite 2209-2217 Eurotowers, Europort Road, Gibraltar</td>
          </tr>
        </tbody>
      </table>
      <ul v-else>
        <li><a class="contact-section-link" href="mailto:claimscomplaints@taurus.gi">claimscomplaints@taurus.gi</a></li>
        <li>The Customer Relations Team, Virgin Money Gadget Insurance, Suite 2209-2217 Eurotowers, Europort Road, Gibraltar</li>
      </ul>
  </form-container>
</template>

<script>
import FormContainer from '@/components/FormContainer.vue'
import {mapGetters} from 'vuex';
export default {
  components: {
    FormContainer
  },
  data: () => {
    return {
      window: {
        width: 0
      }
    }
  },
  computed: {
    ...mapGetters({      
      getReseller: 'reseller/getResellerInfo',      
    }),
    getComplaints() {
      return this.getReseller.complaints
    },
    getComplaintsAddressHtml() {
      let html = '<p>'

      let { address } =  this.getComplaints
      for (let key in address) {
        if (address[key]) {
          html += address[key]
          html += '<br />'
        }
      }
      return html + '</p>'
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth
    }
  }
}
</script>
<style>
.contact-section-header {
  margin-bottom:1.5rem;
}
.contact-section-text {
  margin-bottom: 1.5rem;
}
/* .contact-section-link {
  color: #000000;
  cursor: pointer;
  text-decoration: none;
}
.contact-section-link a:hover {
  color: var(--colour-hover);
  text-decoration: underline;
} */
.table-stacked {
  margin-bottom:2rem;
}

.table a {
  color: #000000;
  cursor: pointer;
  text-decoration: none;
}
.table a:hover {
  color: #E10A0A;
  text-decoration: underline;
}

li a {
  color: #000000;
  cursor: pointer;
  text-decoration: none;
}
li a:hover {
  color: #E10A0A;
  text-decoration: underline;
}
</style>
